import supportedEndpoints from './supportedEndpoints.json'

interface HttpEndpointContract {
  chat: string
  audio: string
  fnaComplete: string
  fnaSummary: string
  canonicalIncome: string
  netWorthHistory: string
  plaidAccessToken: string
  plaidLinkToken: string
  plaidExchangePublicToken: string
  plaidTransactions: string
  apiHealth: string
  authToken: string
  mobileAuthToken: string
  accountDeletion: string
  accountDeletionMobile: string
  accountDeletionCancel: string
  linkedAccounts: string
  linkedAccountsRefresh: string
  disconnectPlaid: string
}

interface WebSocketEndpointContract {
  conversation: string
  audio: string
  askClaude: string
  geminiLive: string
}

interface SupportedEndpointContract {
  http: HttpEndpointContract
  websocket: WebSocketEndpointContract
}

export const SUPPORTED_ENDPOINTS = supportedEndpoints as SupportedEndpointContract
export const HTTP_ENDPOINTS = SUPPORTED_ENDPOINTS.http
export const WEBSOCKET_ENDPOINTS = SUPPORTED_ENDPOINTS.websocket
